import React, { useEffect, useRef, useState } from 'react'

import FF4J from './ff4j'
import useUpdateEffect from './useUpdateEffect'

export const FeatureFlag = React.createContext(null)

const FF4JProvider = ({ config, context = {}, children }) => {
    const ff4j = useRef(new FF4J(config, context))
    const [initialized, setInitialized] = useState(false)

    useEffect(() => {
        const start = async () => {
            try {
                await ff4j.current.fetchFeatures()
            } catch (err) {
                console.error(
                    "Feature flags initial fetch can't be finished",
                    err
                )
            } finally {
                setInitialized(true)
            }

            ff4j.current.fetchLoop()
        }
        start()

        return () => ff4j.current.clean()
    }, [])

    useUpdateEffect(() => {
        ff4j.current.updateContext(context)
    }, [context])

    return (
        <FeatureFlag.Provider value={ff4j.current}>
            {initialized && children}
        </FeatureFlag.Provider>
    )
}

export default FF4JProvider
